var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "position-relative w-100" },
    [
      !_vm.readonly && _vm.normalizedWorkers.length > 0
        ? _c(
            "div",
            {
              staticClass:
                "d-flex align-items-center justify-content-between mb-3"
            },
            [
              _c("div", { staticClass: "d-flex align-items-center" }, [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.currentMonth,
                        expression: "currentMonth"
                      }
                    ],
                    staticClass: "custom-select-filters mr-2",
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.currentMonth = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      }
                    }
                  },
                  _vm._l(_vm.availableMonths, function(month) {
                    return _c(
                      "option",
                      { key: month.index, domProps: { value: month.index } },
                      [_vm._v(_vm._s(month.name))]
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.currentYear,
                        expression: "currentYear"
                      }
                    ],
                    staticClass: "custom-select-filters",
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.currentYear = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      }
                    }
                  },
                  _vm._l(_vm.availableYears, function(year) {
                    return _c(
                      "option",
                      { key: year, domProps: { value: year } },
                      [_vm._v(_vm._s(year))]
                    )
                  }),
                  0
                )
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "custom-btn-secondary",
                  class: { "is-btn-flashing": _vm.isBtnFlashing },
                  attrs: { id: "planning-btn", type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.startPlanning()
                    }
                  }
                },
                [
                  _c("v-icon", {
                    staticClass: "mr-1",
                    attrs: { name: "buttons/calendar", size: 16 }
                  }),
                  _vm._v("\n      Запланировать\n    ")
                ],
                1
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "scrollContainer",
          staticClass: "timesheet-container",
          class: {
            "is-planning": _vm.planningMode,
            "is-flashing": _vm.isFlashing,
            "scroll-locked": _vm.scrollLocked
          }
        },
        [
          _vm.normalizedWorkers.length > 0
            ? _c("div", [
                _c(
                  "div",
                  { staticClass: "timesheet-row timesheet-header" },
                  [
                    _c("div", { staticClass: "worker-col-header text-muted" }, [
                      _vm._v("Исполнители")
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.daysInCurrentMonth, function(day, dIndex) {
                      return _c(
                        "div",
                        {
                          key: day.dateString,
                          staticClass: "day-header-cell",
                          class: {
                            "is-weekend": day.isWeekend,
                            "is-col-hovered": _vm.hoveredDayIndex === dIndex,
                            "is-clickable": !_vm.readonly && !_vm.planningMode
                          },
                          attrs: {
                            id: day.dayNumber === 5 ? "target-cell-5" : null
                          },
                          on: {
                            click: function($event) {
                              return _vm.toggleColumn(day.dateString)
                            }
                          }
                        },
                        [
                          _c("span", { staticClass: "day-name" }, [
                            _vm._v(_vm._s(day.dayName))
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "day-number" }, [
                            _vm._v(_vm._s(day.dayNumber))
                          ])
                        ]
                      )
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "timesheet-body",
                    on: {
                      mouseleave: function($event) {
                        _vm.hoveredDayIndex = null
                      }
                    }
                  },
                  _vm._l(_vm.normalizedWorkers, function(worker, wIndex) {
                    return _c(
                      "div",
                      { key: worker.id, staticClass: "timesheet-row" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "worker-col-name text-truncate",
                            attrs: { title: worker.name }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(worker.name) +
                                "\n          "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _vm._l(_vm.daysInCurrentMonth, function(day, dIndex) {
                          return _c("div", {
                            key: day.dateString,
                            staticClass: "day-cell",
                            class: {
                              "is-selected": _vm.isSelected(
                                worker.id,
                                day.dateString
                              ),
                              "is-readonly": _vm.readonly,
                              "is-disabled":
                                _vm.planningMode &&
                                !_vm.isSelected(worker.id, day.dateString),
                              "is-col-hovered": _vm.hoveredDayIndex === dIndex,
                              "is-dragged": _vm.isCellInDragArea(wIndex, dIndex)
                            },
                            attrs: {
                              id: day.dayNumber === 1 ? "target-cell-1" : null
                            },
                            on: {
                              mouseenter: function($event) {
                                return _vm.onMouseEnter(
                                  wIndex,
                                  dIndex,
                                  worker.id,
                                  day.dateString
                                )
                              },
                              mousedown: function($event) {
                                $event.preventDefault()
                                return _vm.onMouseDown(
                                  wIndex,
                                  dIndex,
                                  worker.id,
                                  day.dateString
                                )
                              }
                            }
                          })
                        })
                      ],
                      2
                    )
                  }),
                  0
                )
              ])
            : !_vm.readonly
            ? _c(
                "div",
                { staticClass: "empty-state-container mt-5" },
                [
                  _c("v-icon", {
                    attrs: { name: "navbar/empty_table", size: 90 }
                  }),
                  _vm._v(" "),
                  _c("h5", [_vm._v("Нет исполнителей для отображения.")]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "Сначала добавьте исполнителей, прежде чем перейти к табелю"
                    )
                  ])
                ],
                1
              )
            : _c(
                "div",
                { staticClass: "p-3 text-muted text-center w-100" },
                [
                  _c("v-icon", {
                    attrs: { name: "navbar/empty_table", size: 90 }
                  }),
                  _vm._v("\n      Нет исполнителей для отображения\n    ")
                ],
                1
              )
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            title: "Планирование работ",
            size: "md",
            centered: "",
            "modal-class": "custom-modal"
          },
          on: { hidden: _vm.cancelPlanning },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function() {
                return [
                  _c(
                    "div",
                    { staticClass: "w-100 d-flex justify-content-end" },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "custom-btn-secondary mr-2",
                          attrs: { size: "sm" },
                          on: {
                            click: function($event) {
                              _vm.isPlaningModalOpen = false
                            }
                          }
                        },
                        [_vm._v("Отмена")]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          staticClass: "custom-btn-primary",
                          attrs: { variant: "primary", size: "sm" },
                          on: { click: _vm.savePlaningData }
                        },
                        [_vm._v("Сохранить")]
                      )
                    ],
                    1
                  )
                ]
              },
              proxy: true
            }
          ]),
          model: {
            value: _vm.isPlaningModalOpen,
            callback: function($$v) {
              _vm.isPlaningModalOpen = $$v
            },
            expression: "isPlaningModalOpen"
          }
        },
        [
          _c(
            "b-tabs",
            { staticClass: "custom-tabs" },
            [
              _c(
                "b-tab",
                { attrs: { title: "Запланированные работы", active: "" } },
                [
                  _c(
                    "b-card",
                    { staticClass: "custom-card my-2" },
                    [
                      _c(
                        "b-form-group",
                        { attrs: { label: "Время начала" } },
                        [
                          _c("b-form-input", {
                            attrs: { type: "time" },
                            model: {
                              value: _vm.workerItems.start_time,
                              callback: function($$v) {
                                _vm.$set(_vm.workerItems, "start_time", $$v)
                              },
                              expression: "workerItems.start_time"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("b-card", { staticClass: "custom-card" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "w-100 d-flex align-items-center justify-content-between"
                      },
                      [
                        _c(
                          "b-form-group",
                          {
                            staticClass: "w-100 mr-2",
                            attrs: { label: "Дата окончания" }
                          },
                          [
                            _c("b-form-input", {
                              attrs: { type: "date" },
                              model: {
                                value: _vm.workerItems.end_date,
                                callback: function($$v) {
                                  _vm.$set(_vm.workerItems, "end_date", $$v)
                                },
                                expression: "workerItems.end_date"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form-group",
                          {
                            staticClass: "w-100",
                            attrs: { label: "Время окончания" }
                          },
                          [
                            _c("b-form-input", {
                              attrs: { type: "time" },
                              model: {
                                value: _vm.workerItems.end_time,
                                callback: function($$v) {
                                  _vm.$set(_vm.workerItems, "end_time", $$v)
                                },
                                expression: "workerItems.end_time"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-card",
                    { staticClass: "custom-card my-2" },
                    [
                      _vm._l(_vm.formattedLocationWorks, function(work, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "mb-2" },
                          [
                            _c(
                              "b-row",
                              { staticClass: "align-items-end" },
                              [
                                _c(
                                  "b-col",
                                  { attrs: { cols: "9" } },
                                  [
                                    _c(
                                      "b-form-group",
                                      { attrs: { label: "Вид работ" } },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "position-relative" },
                                          [
                                            _c("b-form-input", {
                                              attrs: {
                                                value: work.work_type_name,
                                                readonly: ""
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "meta-info-overlay"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(work.rate) +
                                                    " " +
                                                    _vm._s(
                                                      _vm.getUnitByCode(
                                                        work.unit_code
                                                      ).shortName
                                                    ) +
                                                    "\n                    "
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  { attrs: { cols: "3" } },
                                  [
                                    _c(
                                      "b-form-group",
                                      { attrs: { label: "Кол-во" } },
                                      [
                                        work.unit_code === "539"
                                          ? _c("b-form-input", {
                                              attrs: {
                                                value: _vm.calculatedHours,
                                                disabled: ""
                                              }
                                            })
                                          : _c("b-form-input", {
                                              attrs: { type: "number" },
                                              model: {
                                                value:
                                                  _vm.workerItems.total_units,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.workerItems,
                                                    "total_units",
                                                    _vm._n($$v)
                                                  )
                                                },
                                                expression:
                                                  "workerItems.total_units"
                                              }
                                            })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      }),
                      _vm._v(" "),
                      _vm.formattedLocationWorks.length === 0
                        ? _c(
                            "div",
                            { staticClass: "text-center text-muted p-2" },
                            [
                              _vm._v(
                                "\n            Вид работ не выбран\n          "
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    2
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-tab",
                { attrs: { title: "Расходы" } },
                [
                  _c(
                    "b-card",
                    { staticClass: "custom-card mt-2" },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { staticClass: "mb-3", attrs: { cols: "6" } },
                            [
                              _c(
                                "b-form-group",
                                { attrs: { label: "Ставка" } },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      type: "number",
                                      step: "0.5",
                                      min: "0"
                                    },
                                    model: {
                                      value: _vm.workerItems.price,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.workerItems,
                                          "price",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression: "workerItems.price"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { staticClass: "mb-3", attrs: { cols: "6" } },
                            [
                              _c(
                                "b-form-group",
                                { attrs: { label: "Обед" } },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      type: "number",
                                      step: "0.5",
                                      min: "0"
                                    },
                                    model: {
                                      value: _vm.workerItems.dinner,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.workerItems,
                                          "dinner",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression: "workerItems.dinner"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { staticClass: "mb-3", attrs: { cols: "6" } },
                            [
                              _c(
                                "b-form-group",
                                { attrs: { label: "Трансфер" } },
                                [
                                  _c("b-form-input", {
                                    attrs: { type: "number", min: "0" },
                                    model: {
                                      value: _vm.workerItems.road_price,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.workerItems,
                                          "road_price",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression: "workerItems.road_price"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { staticClass: "mb-3", attrs: { cols: "6" } },
                            [
                              _c(
                                "b-form-group",
                                { attrs: { label: "Аванс" } },
                                [
                                  _c("b-form-input", {
                                    attrs: { type: "number", min: "0" },
                                    model: {
                                      value: _vm.workerItems.prepaid,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.workerItems,
                                          "prepaid",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression: "workerItems.prepaid"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-50dffc68", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50dffc68","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tasks/TaskTimesheet.vue
// module id = null
// module chunks = 